import React from 'react';
import { LoadingDot, LoadingDotsRoot } from './styles';

interface LoadingDotsProps {
    className?: string;
    color?: 'primary' | 'secondary' | 'alt';
}

const LoadingDots: React.FCC<LoadingDotsProps> = (props) => {
    return (
        <LoadingDotsRoot className={props.className}>
            <LoadingDot loadingColor={props.color} animationDelay="0s" />
            <LoadingDot loadingColor={props.color} animationDelay="0.1s" />
            <LoadingDot loadingColor={props.color} animationDelay="0.2s" />
        </LoadingDotsRoot>
    );
};

export default LoadingDots;
